import React from "react";

import "./cell.styles.scss";

export type CellProps = {
  children: React.ReactNode;
  id: string;
};

export const Cell: React.FC<CellProps> = ({ id, children }) => {
  return (
    <td id={id} className="FieldQueryTableBodyRowCell">
      {children}
    </td>
  );
};
